export default {
  RotifyWebsiteUrl: 'https://www.rotify.co.uk'
};
